import { PortfolioInfo } from '../types/portfolio';

export const portfolioData: PortfolioInfo = {
  name: 'Inder',
  lastName: 'Singh',
  fullName: 'Inderpal Singh',
  role: 'Senior Full Stack Developer & Architect',
  email: 'inders.tech@gmail.com',
  phone: '',
  phoneCode: '',
  whatsappUsername: 'inders.tech',
  whatsappUrl: 'https://wa.me/inders.tech',
  address: 'Mohali, Punjab, India',
  totalExperience: 12,
  profilePic: '/assets/images/profile.png',
  linkedin: 'https://linkedin.com/in/ips13',
  github: 'https://github.com/ips13',
  resumeUrl: '/Resume-Inderpal-Singh.pdf',
  intro: 'Senior Full Stack Developer & Technical Architect with 12+ years of experience engineering high-throughput web systems, distributed APIs, and cloud infrastructure. Expert in React, Angular, Node.js, Python, Java, and AWS.',
  description: 'Proven track record delivering mission-critical applications for global enterprises including Events.com, Cisco, and Lucid Motors. Specialized in scaling database migrations (2TB+), optimizing cloud microservices, and driving Agile velocity.',
  highlights: [
    'Spearheaded development of Cisco\'s award-winning "Master Boot Record (MBR)" system.',
    'Engineered global, multi-country Point of Sale (POS) infrastructure for Lucid Motors using Ionic & Node.js.',
    'Architected core Sell Department modules for Events.com: AUI (Admin), Sell RUI (Ticket Sales & Registrations), POS, Java Backend Services, and Promote Panel.',
    'Led zero-downtime migration of 2TB+ relational dataset to indexed MySQL on AWS for Canada\'s largest survey engine.',
  ],
  stats: {
    yearsExp: 12,
    projectsCompleted: 300,
    companiesWorked: 3,
    satisfiedClients: 15,
  },
  clients: [
    {
      name: 'Cisco Systems',
      category: 'Enterprise Tech',
      impact: 'Award-Winning MBR System',
      badge: 'Fortune 500',
    },
    {
      name: 'Lucid Motors',
      category: 'Automotive & EV',
      impact: 'Global Multi-Country POS Engine',
      badge: 'Global Enterprise',
    },
    {
      name: 'Events.com',
      category: 'Event Tech Platform',
      impact: 'Sell Department (AUI, Sell RUI, POS, Java Backend, Promote)',
      badge: 'Industry Leader',
    },
    {
      name: 'Upped Events',
      category: 'Event Management',
      impact: 'Real-Time Vendor Operations & POS',
      badge: 'Enterprise SaaS',
    },
    {
      name: 'Canadian Survey Platform',
      category: 'Data & Analytics',
      impact: '2TB AWS Database Migration',
      badge: 'National Scale',
    },
    {
      name: 'Motoview',
      category: 'Automotive Digital',
      impact: 'Iceberg API Showroom Aggregator',
      badge: 'Global Platform',
    },
  ],
  skills: [
    { name: 'Java / Spring Boot', percent: 90, slug: 'java', category: 'backend' },
    { name: 'Node.JS / Express', percent: 100, slug: 'nodejs', category: 'backend' },
    { name: 'React.js / Next.js', percent: 99, slug: 'react', category: 'frontend' },
    { name: 'Angular (2+)', percent: 100, slug: 'angular', category: 'frontend' },
    { name: 'TypeScript / JS', percent: 100, slug: 'typescript', category: 'frontend' },
    { name: 'PHP / Laravel', percent: 100, slug: 'php', category: 'backend' },
    { name: 'Python / Django', percent: 88, slug: 'python', category: 'backend' },
    { name: 'AWS (Lambda, S3, EC2, DynamoDB)', percent: 92, slug: 'aws', category: 'cloud' },
    { name: 'Docker / Containers', percent: 85, slug: 'docker', category: 'cloud' },
    { name: 'CI/CD & Jenkins', percent: 80, slug: 'jenkins', category: 'cloud' },
    { name: 'Microservices & REST APIs', percent: 95, slug: 'microservices', category: 'backend' },
    { name: 'MySQL & PostgreSQL', percent: 99, slug: 'mysql', category: 'database' },
    { name: 'MongoDB / NoSQL', percent: 97, slug: 'nosql', category: 'database' },
    { name: 'Ionic / Mobile POS', percent: 95, slug: 'ionic', category: 'frontend' },
    { name: 'React Native', percent: 92, slug: 'reactnative', category: 'frontend' },
    { name: 'WordPress / Headless CMS', percent: 100, slug: 'wordpress', category: 'cms' },
    { name: 'Shopify / E-Commerce', percent: 90, slug: 'shopify', category: 'cms' },
    { name: 'Magento 2', percent: 85, slug: 'magento', category: 'cms' },
  ],
  experiences: [
    {
      title: 'Senior Full Stack Architect (Contract)',
      company: 'Professional Services / Enterprise Clients',
      address: 'Remote / Mohali, India',
      startDate: 'Jun 2021',
      endDate: 'Present',
      description: 'Architecting high-scale web platforms, distributed systems, and enterprise POS/event software for market leaders (Events.com Sell Department, Cisco MBR, Lucid Motors POS):',
      technologies: ['Java', 'Spring Boot', 'React', 'Angular', 'Node.js', 'AWS', 'Docker', 'Ionic', 'MySQL'],
    },
    {
      title: 'Technical Lead',
      company: 'Illuminz',
      address: 'Mohali, Punjab',
      startDate: 'Jun 2018',
      endDate: 'May 2021',
      description: 'Led a cross-functional engineering team building scalable SaaS and mobile products. Championed Agile practices resulting in a 30% surge in delivery velocity within 6 months. Served as principal technical liaison for global clients.',
      technologies: ['Angular', 'Node.js', 'PHP', 'MongoDB', 'MySQL', 'AWS'],
    },
    {
      title: 'Senior Software Developer',
      company: 'Webclouds',
      address: 'Mohali, Punjab',
      startDate: 'Oct 2013',
      endDate: 'May 2018',
      description: 'Spearheaded full lifecycle software engineering, client roadmap planning, and production deployment across web applications, custom CMS solutions, and e-commerce platforms.',
      technologies: ['PHP', 'JavaScript', 'WordPress', 'Magento', 'MySQL'],
    },
  ],
  projects: [
    {
      id: 'lucid-pos',
      name: 'Lucid Motors Store POS Platform',
      clientName: 'Lucid Motors',
      link: 'https://lucidmotors.com',
      image: '/assets/images/projects/lucid-pos.png',
      description: 'Engineered a global, multi-country Point of Sale (POS) retail store application for Lucid Motors EV showrooms, enabling customers and store staff to purchase vehicle accessories, chargers, apparel, and hardware directly through tablet POS terminals.',
      technologies: ['Ionic', 'React', 'Node.js', 'AWS', 'Docker', 'REST API'],
      category: 'Enterprise',
      featured: true,
      highlights: [
        'Multi-country multi-currency POS transaction checkout for electric vehicle retail stores.',
        'Seamless inventory & catalog integration for charging accessories, apparel, and vehicle add-ons.',
        'Offline-capable transaction queue built with Ionic and Node.js microservices.'
      ],
      metrics: [
        { label: 'Global Retail POS', value: 'Multi-Country' },
        { label: 'Transaction Speed', value: '< 1.5 secs' },
        { label: 'Uptime', value: '99.99%' }
      ],
      architecture: 'Ionic cross-platform tablet client with Node.js microservice architecture containerized on AWS EC2 & Docker.'
    },
    {
      id: 'cisco-mbr',
      name: 'Cisco Master Boot Record (MBR) Portal',
      clientName: 'Cisco Systems',
      link: 'https://cisco.com',
      image: '/assets/images/projects/cisco-mbr.png',
      description: 'Architected and developed Cisco\'s award-winning "Master Boot Record (MBR)" application, a mission-critical enterprise portal for monitoring network hardware topology, system integrity verification, device health analytics, and automated configuration workflows.',
      technologies: ['Angular', 'Node.js', 'Microservices', 'REST API', 'MySQL', 'TypeScript'],
      category: 'Enterprise',
      featured: true,
      highlights: [
        'Award-winning enterprise network hardware configuration and MBR integrity portal.',
        'Real-time network topology visualization graph with instant health alerts and telemetry.',
        'High-throughput system configuration workflow managing thousand-node deployments.'
      ],
      metrics: [
        { label: 'Network Devices', value: '10,000+' },
        { label: 'MBR Verification', value: 'Real-time' },
        { label: 'Award', value: 'Cisco Excellence' }
      ],
      architecture: 'Angular single-page enterprise dashboard integrated with Node.js microservices and indexed MySQL storage.'
    },
    {
      id: 'events-cisco-lucid',
      name: 'Events.com Sell & Operations Ecosystem',
      clientName: 'Events.com',
      link: 'https://events.com',
      image: '/assets/images/projects/events-com.png',
      description: 'Architected and engineered key core modules within the Events.com Sell Department: AUI (Admin UI), Sell RUI (Ticket Sales & Registrations), On-Site POS Terminals, High-Performance Java Backend Microservices, and the Promote Panel for publishing and scheduling social marketing posts.',
      technologies: ['Java', 'Spring Boot', 'React', 'Angular', 'Node.js', 'AWS', 'Docker', 'MySQL', 'REST API'],
      category: 'Enterprise',
      featured: true,
      highlights: [
        'AUI (Admin) & Sell RUI: Built event configuration portal and high-conversion ticket sales & registration checkout flow.',
        'POS & Java Backend Services: Engineered event terminal software and scalable Java microservices for real-time transactions.',
        'Promote Panel: Developed social marketing management suite enabling organizers to publish and schedule posts directly through the panel.'
      ],
      metrics: [
        { label: 'Core Dept', value: 'Sell & Admin' },
        { label: 'Backend Stack', value: 'Java Microservices' },
        { label: 'Modules', value: 'AUI, Sell RUI, POS, Promote' }
      ],
      architecture: 'Distributed Java microservices with React & Angular modules (AUI, Sell RUI, Promote) and on-site POS terminal synchronization deployed on AWS.'
    },
    {
      id: 'motoview',
      name: 'Motoview Digital Showroom Aggregator',
      clientName: 'Motoview Inc.',
      link: 'https://motoview.com',
      image: '/assets/images/projects/motoview.png',
      description: 'Premier automotive aggregation platform integrated with Iceberg API. Curates live vehicle displays from international motor shows, offering advanced car comparisons, social engagement (likes/dislikes), and interactive community discussions.',
      technologies: ['Angular', 'Lumen', 'MySQL', 'Iceberg API', 'REST API'],
      category: 'Full Stack',
      featured: true,
      highlights: [
        'Real-time synchronization with international motor show vehicle data via Iceberg API.',
        'Interactive vehicle comparison module with specs filtering.',
        'Community engagement system with social feedback & threaded discussions.'
      ],
      metrics: [
        { label: 'API Sync Speed', value: '< 120ms' },
        { label: 'Car Models Cataloged', value: '10,000+' },
        { label: 'User Rating', value: '4.9/5' }
      ],
      architecture: 'Angular single-page client coupled with Lumen PHP micro-framework and indexed MySQL database.'
    },
    {
      id: 'ethnico',
      name: 'Ethnico Artisan Marketplace',
      clientName: 'Ethnico Fashion Group',
      link: 'https://ethnico.in',
      image: '/assets/images/projects/ethnico.png',
      description: 'Hyperlocal artisan marketplace bringing bespoke tailoring and readymade ethnic wear directly to consumers, connecting boutique fashion houses across India with a seamless digital ordering experience.',
      technologies: ['Angular', 'Node.js', 'MySQL', 'MongoDB', 'Payment Gateway'],
      category: 'Full Stack',
      featured: true,
      highlights: [
        'Digitized complete boutique tailoring pipeline from custom measurement input to doorstep delivery.',
        'Multi-vendor catalog management supporting hundreds of fashion artisans.',
        'Unified payment processing and automated dispatch notifications.'
      ],
      metrics: [
        { label: 'Boutiques Onboarded', value: '250+' },
        { label: 'Order Processing', value: 'Instant' }
      ],
      architecture: 'Modular Angular frontend with Node.js API server & dual SQL/NoSQL storage strategy.'
    },
    {
      id: 'lexbot',
      name: 'AWS Sentiment Analysis Lex Bot',
      clientName: 'Canadian National Survey',
      image: '/assets/images/projects/lexbot.png',
      description: 'Intelligent NLP chatbot built for Canadian national survey analysis. Dynamically alters survey branches using real-time AWS Lambda sentiment analysis and custom natural language grammar engines.',
      technologies: ['AWS Lambda', 'Python', 'DynamoDB', 'AWS Lex', 'NLP Engine'],
      category: 'AI & Cloud',
      featured: true,
      highlights: [
        'Real-time sentiment scoring on open-text survey answers.',
        'Dynamic branch switching based on user emotion & feedback intensity.',
        'Zero-server infrastructure built entirely on serverless AWS Lambda and DynamoDB.'
      ],
      metrics: [
        { label: 'Survey Response Rate', value: '+45%' },
        { label: 'Data Migrated', value: '2 TB' },
        { label: 'Sentiment Accuracy', value: '94%' }
      ],
      architecture: 'Serverless architecture utilizing AWS Lex conversational bot, Python Lambda handlers, and DynamoDB storage.'
    },
    {
      id: 'delivery-papa',
      name: 'Delivery Papa Multi-Vendor Platform',
      clientName: 'Delivery Papa',
      link: 'http://dp.illuminz.com',
      image: '/assets/images/projects/delivery-papa.png',
      description: 'Multi-vendor food delivery and logistics platform featuring individual vendor database management, automated multi-provider dispatching, real-time tracking, and POS integrations.',
      technologies: ['Angular', 'Node.js', 'React', 'Next.js', 'MongoDB', 'WebSockets'],
      category: 'Mobile',
      featured: false,
      highlights: [
        'Real-time WebSocket rider tracking and automated order dispatching.',
        'Gamified loyalty application with tier-based rewards for active diners.',
        'Integrated table reservation and point-of-sale terminal syncing.'
      ],
      metrics: [
        { label: 'Dispatch Time', value: '< 2 secs' },
        { label: 'Vendors Supported', value: '500+' }
      ],
      architecture: 'Next.js merchant portal, React consumer web app, and Node.js microservices with WebSocket streaming.'
    },
    {
      id: 'upped-events',
      name: 'Upped Events Platform',
      clientName: 'Upped Events Inc.',
      link: 'http://uppedevents.com',
      image: '/assets/images/projects/upped.png',
      description: 'Comprehensive event management command center managing ticketing, merchandise sales, staff scheduling, live access control, and actionable analytics dashboards for organizers.',
      technologies: ['Angular', 'Node.js', 'MySQL', 'MongoDB', 'QR Validation'],
      category: 'Enterprise',
      featured: false,
      highlights: [
        'High-speed QR code ticket scanning and staff access verification.',
        'Real-time event analytics dashboard tracking revenue and attendee flow.',
        'On-site merchandise sales and vendor payout automation.'
      ],
      metrics: [
        { label: 'Tickets Validated/Min', value: '1,200+' },
        { label: 'Event Capacity', value: '50,000+' }
      ],
      architecture: 'Angular web management console backed by Node.js APIs and high-availability MySQL database.'
    },
    {
      id: 'gigipo',
      name: 'Gigipo Virtual EdTech Platform',
      clientName: 'Gigipo Learning',
      link: 'https://dev.gigipo.com',
      image: '/assets/images/projects/gigipo.png',
      description: 'Interactive ed-tech platform connecting expert mentors with students. Features JITSI video conferencing integration, instant session booking, resource sharing, and custom class-gifting functionality.',
      technologies: ['React', 'Node.js', 'JITSI SDK', 'MySQL', 'Stripe'],
      category: 'Full Stack',
      featured: false,
      highlights: [
        'HD video classroom integration using JITSI Meet SDK.',
        'Real-time calendar scheduling and mentor availability matching.',
        'Integrated "Gift a Class" digital voucher system.'
      ],
      metrics: [
        { label: 'Video Quality', value: '1080p HD' },
        { label: 'Session Reliability', value: '99.9%' }
      ],
      architecture: 'React SPA frontend with Node.js REST API and self-hosted JITSI WebRTC server instance.'
    }
  ],
  services: [
    {
      title: 'Full Stack System Architecture',
      description: 'End-to-end design and implementation of resilient, high-throughput web services, REST/GraphQL APIs, and frontend applications.',
      icon: 'Cpu',
      colorClass: 'accent-1',
    },
    {
      title: 'Enterprise Software & Cloud',
      description: 'Architecting scalable microservices on AWS/Docker, serverless computing, database optimization, and high-availability setups.',
      icon: 'Cloud',
      colorClass: 'accent-2',
    },
    {
      title: 'Technical Leadership & Mentorship',
      description: 'Guiding engineering teams, establishing rigorous CI/CD & code review standards, and accelerating Agile release cycles.',
      icon: 'Users',
      colorClass: 'accent-3',
    },
    {
      title: 'Angular & React Mastery',
      description: 'Designing performant, modern Single Page Applications and Design Systems using React, Angular, Next.js, and TypeScript.',
      icon: 'Code2',
      colorClass: 'accent-4',
    },
    {
      title: 'Node.js & Backend Engineering',
      description: 'Building ultra-fast asynchronous APIs, real-time socket services, and microservices with Node.js, Express, and Hapi.',
      icon: 'Server',
      colorClass: 'accent-5',
    },
    {
      title: 'Database & Data Migration',
      description: 'Expert SQL/NoSQL schema design, query indexing, and zero-downtime migration of terabyte-scale database architectures.',
      icon: 'Database',
      colorClass: 'accent-6',
    },
  ],
  educations: [
    {
      title: 'Bachelor of Science in Information Technology (BSc IT)',
      institute: 'Kalinga University',
      startDate: '2014',
      endDate: '2016',
      state: 'Raipur, India',
      totalSems: 4,
      description: 'Advanced studies in Software Engineering, Database Systems Architecture, Distributed Networks, and Computer Security.',
    },
    {
      title: 'Diploma in Information Technology (DIT)',
      institute: 'Punjab Infotech',
      startDate: '2012',
      endDate: '2013',
      state: 'Mohali, Punjab, India',
      totalSems: 2,
      description: 'Foundational degree covering programming logic, computer systems, data structures, and web technologies.',
    },
  ],
};
